"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateLumpSumFaceAmount = void 0;
const common_1 = require("../../../../../common");
const common_2 = require("../../../../common");
const get_lump_sum_payment_adjustment_1 = require("./get-lump-sum-payment-adjustment");
const get_lump_sum_payment_method_factor_1 = require("./get-lump-sum-payment-method-factor");
const lump_sum_premium_calculator_1 = require("./lump-sum-premium-calculator");
function calculateLumpSumFaceAmount(options, rate, faceFactor, premiumFactor) {
    const paymentAdjustment = get_lump_sum_payment_adjustment_1.getLumpSumPaymentAdjustment(options);
    const periodFactor = common_1.getPaymentPeriodFactor(options.paymentPeriod);
    const methodFactor = get_lump_sum_payment_method_factor_1.getLumpSumPaymentMethodFactor(options);
    const premium = lump_sum_premium_calculator_1.calculateLumpSumPremium(options, rate, faceFactor, premiumFactor);
    const faceAmount = (premium - paymentAdjustment) / premiumFactor / periodFactor / methodFactor;
    return common_2.roundPayment(faceAmount);
}
exports.calculateLumpSumFaceAmount = calculateLumpSumFaceAmount;
//# sourceMappingURL=lump-sum-face-amount-calculator.js.map